import { UrlMatchResult, UrlSegment } from '@angular/router';

const SCOUT_WHITELISTED_ROUTES: string[] = ['chat', 'results'];

export function matchScoutWhitelistedRoutes(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length === 0 || (segments.length === 1 && SCOUT_WHITELISTED_ROUTES.includes(segments[0].path))) {
    return { consumed: segments };
  }

  return null;
}
